<!--
# -----------------------------------------------------------------------------
# Component: PolicyGroupDetails.vue
# Author: PST
# Created Date: 02/April/2019
# Comments: Policy Risk -> Group Details Tab
# -----------------------------------------------------------------------------
-->
<template>
  <div>
    <v-container fluid grid-list-lg v-if="polMaster.tranType === 'E' && endorseRiskList.length > 0">
      <v-toolbar dense color="grey lighten-5" flat>
        <v-icon>mdi-format-align-justify</v-icon>
        <v-toolbar-title class="toolbar-title-2">{{ labels.endorseTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-layout row wrap>
        <v-flex xs12>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-data-table
                  v-model="riskSelected"
                  :headers="riskHeaders"
                  :items="riskList"
                  item-key="riskGrpNoRiskNo"
                  class="elevation-1"
                  :loading="loading"
                  show-select
                >
                  <!-- <template v-slot:item="row">
                    <tr>
                      <td>{{ row.item.riskGrpNoRiskNo }}</td>
                      <td>{{ row.item.busCls }} - {{ row.item.busClsDesc }}</td>
                      <td>{{ row.item.siCurr }}</td>
                      <td>{{ row.item.siExRate }}</td>
                      <td>{{ row.item.si }}</td>
                    </tr>
                  </template> -->
                </v-data-table>
              </v-flex>
              <v-flex xs12>
                <v-btn text color="primary" @click.prevent="doEndorsementAddGroup"> {{ labels.addNewGroup }}<v-icon>mdi-plus</v-icon> </v-btn>
                <v-btn text color="primary" @click.prevent="doEndorsementAddRisk" :disabled="!disableAll">
                  {{ labels.addNewRisk }}<v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mr-2" color="info" dark @click.prevent="doEndorse" :loading="loading">
                  {{ labels.endorse }}
                  <v-icon dark right>mdi-pencil-box-outline</v-icon>
                </v-btn>
                <v-btn class="mr-2" color="error" dark @click.prevent="doCancel" :loading="loading">
                  {{ labels.cancel }}
                  <v-icon dark right>mdi-exit-to-app</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-lg v-else>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-5" flat>
              <v-icon>mdi-format-align-justify</v-icon>
              <v-toolbar-title class="toolbar-title-2">{{ labels.mainTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="mx-2" fab dark small color="primary" v-on="on" @click.prevent="doAddGroup">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{ labels.addGroup }}</span>
              </v-tooltip>
            </v-toolbar>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table :headers="headers" :items="items" class="elevation-1" :loading="loading">
                      <template v-slot:item="row">
                        <tr>
                          <td>{{ row.item.riskGrpNo }}</td>
                          <td>{{ row.item.planDesc }}</td>
                          <td>{{ row.item.noDay }}</td>
                          <td>{{ row.item.noAdult }}</td>
                          <td>{{ row.item.noChild }}</td>
                          <td>{{ row.item.noLive }}</td>
                          <td>{{ row.item.delRiskGrp }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              review
                              @review="doSelect(row.item)"
                              :remove="
                                (polMaster.tranType === 'N' ||
                                  polMaster.tranType === 'R' ||
                                  (polMaster.tranType !== 'N' && polMaster.tranType !== 'R' && row.item.delRiskGrp !== 'YES'))
                              "
                              @remove="doPromptRemove(row.item)"
                              :undo="
                                polMaster.tranType !== 'N' &&
                                polMaster.tranType !== 'R' &&
                                row.item.delRiskGrp === 'YES'
                              "
                              undoText="Undo Delete Risk Group"
                              @undo="doPromptUndoDelRiskGrp(row.item)"
                            ></table-action>
                          </td>
                          <!-- <td style="margin: 0 auto;">
                          <v-tooltip bottom v-if="!disableAll">
                            <v-btn icon v-on="on" color="primary" flat @click.prevent="doSelect(row.item)" :loading="policy.loading">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <span>{{labels.updateGroup}}</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="disableAll">
                            <v-btn icon v-on="on" color="primary" flat @click.prevent="doSelect(row.item)" :loading="policy.loading">
                              <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                            <span>{{labels.updateGroup}}</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="!disableAll">
                            <v-btn icon v-on="on" color="red" flat @click.prevent="doPromptRemove(row.item)" :loading="policy.loading">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                            <span>{{labels.delRiskGrp}}</span>
                          </v-tooltip>
                        </td> -->
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12 v-show="showExpandRiskGrp">
                    <v-card>
                      <v-toolbar dense color="grey lighten-5" flat>
                        <v-icon>mdi-format-align-justify</v-icon>
                        <v-toolbar-title class="toolbar-title-3">Risk Group Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <!-- <v-btn class="mx-2" fab dark small color="purple" v-on="on" @click.native="doRiskGrpTxtDialog" :disabled="disableAll"> -->
                            <v-btn class="mx-2" fab dark small color="purple" v-on="on" @click.native="doRiskGrpTxtDialog">
                              <v-icon dark>mdi-note-text</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ labels.riskGrpTxt }}</span>
                        </v-tooltip>
                        <v-btn text icon @click="showExpandRiskGrp = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex lg2 xs6>
                              <v-text-field
                                v-model="mainForm.riskGrpNo"
                                :label="labels.riskGrpNo"
                                :error-messages="errors.collect('riskGrpNo')"
                                data-vv-name="riskGrpNo"
                                :data-vv-as="labels.riskGrpNo"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg2 xs6>
                              <v-checkbox v-model="mainForm.delRiskGrp" :label="labels.delRiskGrp" readonly></v-checkbox>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="mainForm.noDay"
                                :label="labels.noDay"
                                :error-messages="errors.collect('noDay')"
                                data-vv-name="noDay"
                                :data-vv-as="labels.noDay"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs6>
                              <v-text-field
                                v-model="mainForm.noAdult"
                                :label="labels.noAdult"
                                :error-messages="errors.collect('noAdult')"
                                data-vv-name="noAdult"
                                :data-vv-as="labels.noAdult"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs12>
                              <v-autocomplete
                                :items="pkgPlanList"
                                v-model="mainForm.planNo"
                                :label="labels.planNo"
                                item-text="label"
                                item-value="value"
                                data-vv-name="planNo"
                                :data-vv-as="labels.planNo"
                                :error-messages="errors.collect('planNo')"
                                :disabled="disablePlan"
                                v-validate="'required'"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex lg4 xs12>
                              <v-text-field
                                v-model="mainForm.noChild"
                                :label="labels.noChild"
                                :error-messages="errors.collect('noChild')"
                                data-vv-name="noChild"
                                :data-vv-as="labels.noChild"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 xs12>
                              <v-text-field
                                v-model="mainForm.noLive"
                                :label="labels.noLive"
                                :error-messages="errors.collect('noLive')"
                                data-vv-name="noLive"
                                :data-vv-as="labels.noLive"
                                v-validate="'required|numeric|max:4'"
                                v-int-mask="{ intScale: 4 }"
                                type="tel"
                                :disabled="disableAll"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg8 xs12>
                              <v-textarea
                                v-model="mainForm.insdPremises"
                                :label="labels.insdPremises"
                                no-resize
                                rows="3"
                                :error-messages="errors.collect('insdPremises')"
                                data-vv-name="insdPremises"
                                :data-vv-as="labels.insdPremises"
                                :maxlength="200"
                              ></v-textarea>
                            </v-flex>
                            <v-flex lg12 xs12>
                              <v-expansion-panels>
                                <v-expansion-panel :disabled="!allowSubDet" v-if="allowSubDet">
                                  <v-expansion-panel-header>
                                    <div>
                                      <v-icon>mdi-account-multiple-plus</v-icon><span class="headerTitle">{{ labels.subTitle }}</span>
                                    </div>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-card>
                                      <v-card-text>
                                        <v-layout row wrap align-center>
                                          <v-flex lg2 xs12>
                                            <v-text-field
                                              v-model="mainForm.insdRefNo"
                                              :label="labels.insdRefNo"
                                              :error-messages="errors.collect('insdRefNo')"
                                              data-vv-name="insdRefNo"
                                              :data-vv-as="labels.insdRefNo"
                                              v-validate="'max:8'"
                                              readonly
                                            >
                                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                                <v-icon color="info" @click="doShowInsdRefNo('Insured')" v-text="'mdi-magnify'"></v-icon>
                                              </v-slide-x-reverse-transition>
                                            </v-text-field>
                                          </v-flex>
                                          <v-flex lg2 xs12>
                                            <v-autocomplete
                                              :items="salutationList"
                                              v-model="mainForm.titleName"
                                              :label="labels.titleName"
                                              item-text="label"
                                              item-value="value"
                                              data-vv-name="titleName"
                                              :data-vv-as="labels.titleName"
                                              :error-messages="errors.collect('titleName')"
                                              v-validate="'max:3'"
                                              :disabled="disableInsured"
                                            ></v-autocomplete>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-text-field
                                              v-model="mainForm.insdName1"
                                              :label="labels.insdName1"
                                              :error-messages="errors.collect('insdName1')"
                                              data-vv-name="insdName1"
                                              :data-vv-as="labels.insdName1"
                                              v-validate="valInsd"
                                              :disabled="disableInsured"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-text-field
                                              v-model="mainForm.insdName2"
                                              :label="labels.insdName2"
                                              :error-messages="errors.collect('insdName2')"
                                              data-vv-name="insdName2"
                                              :data-vv-as="labels.insdName2"
                                              v-validate="'max:60'"
                                              :disabled="disableInsured"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex xs12>
                                            <v-checkbox v-model="mainForm.mailAdd" :label="labels.mailAdd" @change="doMailAdd()"></v-checkbox>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-text-field
                                              v-model="mainForm.insdAddr1"
                                              :label="labels.insdAddr1"
                                              :error-messages="errors.collect('insdAddr1')"
                                              data-vv-name="insdAddr1"
                                              :data-vv-as="labels.insdAddr1"
                                              v-validate="valInsd"
                                              :disabled="disableInsured"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-text-field
                                              v-model="mainForm.insdAddr2"
                                              :label="labels.insdAddr2"
                                              :error-messages="errors.collect('insdAddr2')"
                                              data-vv-name="insdAddr2"
                                              :data-vv-as="labels.insdAddr2"
                                              v-validate="'max:60'"
                                              :disabled="disableInsured"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-text-field
                                              v-model="mainForm.insdAddr3"
                                              :label="labels.insdAddr3"
                                              :error-messages="errors.collect('insdAddr3')"
                                              data-vv-name="insdAddr3"
                                              :data-vv-as="labels.insdAddr3"
                                              v-validate="valInsd"
                                              :disabled="disableInsured"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-text-field
                                              v-model="mainForm.insdAddr4"
                                              :label="labels.insdAddr4"
                                              :error-messages="errors.collect('insdAddr4')"
                                              data-vv-name="insdAddr4"
                                              :data-vv-as="labels.insdAddr4"
                                              v-validate="'max:60'"
                                              :disabled="disableInsured"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-text-field
                                              v-model="mainForm.insdAddr5"
                                              :label="labels.insdAddr5"
                                              :error-messages="errors.collect('insdAddr5')"
                                              data-vv-name="insdAddr5"
                                              :data-vv-as="labels.insdAddr5"
                                              v-validate="'max:60'"
                                              :disabled="disableInsured"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-autocomplete
                                              :items="countryList"
                                              v-model="mainForm.insdAddr6"
                                              :label="labels.insdAddr6"
                                              item-text="label"
                                              item-value="value"
                                              data-vv-name="insdAddr6"
                                              :data-vv-as="labels.insdAddr6"
                                              :error-messages="errors.collect('insdAddr6')"
                                              v-validate="valCtyPc"
                                              :disabled="disableInsured"
                                              clearable
                                            ></v-autocomplete>
                                          </v-flex>
                                          <v-flex lg4 xs12>
                                            <v-autocomplete
                                              :items="postalCodList"
                                              v-model="mainForm.postCode"
                                              :label="labels.postCode"
                                              item-text="label"
                                              item-value="value"
                                              data-vv-name="postCode"
                                              :data-vv-as="labels.postCode"
                                              :error-messages="errors.collect('postCode')"
                                              v-validate="valPostcode"
                                              :disabled="disableInsured"
                                              clearable
                                            ></v-autocomplete>
                                          </v-flex>
                                          <v-flex xs12>
                                            <v-card-actions>
                                              <v-spacer></v-spacer>
                                              <v-btn depressed @click.prevent="doReset" :disabled="disableAll"
                                                ><span class="btn-normal-error">{{ labels.reset }}</span></v-btn
                                              >
                                              <v-btn depressed type="submit" @click.prevent="doProceed('Save')" :disabled="disableAll"
                                                ><span class="btn-normal-primary">{{ labels.saveSub }}</span></v-btn
                                              >
                                            </v-card-actions>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                    </v-card>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                                <v-expansion-panel :disabled="!allowInsd" v-show="allowInsd">
                                  <v-expansion-panel-header>
                                    <div>
                                      <v-icon>mdi-account-multiple</v-icon><span class="headerTitle">{{ labels.insdPersonsTitle }}</span>
                                    </div>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-layout row wrap align-center>
                                      <v-flex xs12>
                                        <v-toolbar dense color="grey lighten-3" flat>
                                          <v-spacer></v-spacer>
                                          <v-btn color="primary" dark class="mb-2" @click="doAddPerson" :disabled="disableAll">
                                            {{ labels.addPerson }}
                                            <v-icon right>mdi-plus</v-icon>
                                          </v-btn>
                                        </v-toolbar>
                                        <v-data-table :headers="person.personHeaders" :items="person.personItems" class="elevation-1">
                                          <template v-slot:item="row">
                                            <tr>
                                              <td>{{ row.item.insdRefNo }}</td>
                                              <td>{{ row.item.insdName1 }}</td>
                                              <td>{{ row.item.icNo }}</td>
                                              <td>{{ row.item.dobFormat }}</td>
                                              <td>{{ row.item.age }}</td>
                                              <td class="table-action-header">
                                                <table-action
                                                  :rowData="row"
                                                  review
                                                  @review="doSelectPerson(row.item)"
                                                  :remove="!disableAll"
                                                  @remove="doPromptRemovePerson(row.item)"
                                                ></table-action>
                                              </td>
                                              <!-- <td style="margin: 0 auto;">
                                                <v-tooltip bottom v-if="!disableAll">
                                                  <v-btn icon v-on="on" color="primary" flat @click.prevent="doSelectPerson(row.item)" :loading="policy.loading">
                                                    <v-icon>mdi-pencil</v-icon>
                                                  </v-btn>
                                                  <span>{{labels.updatePerson}}</span>
                                                </v-tooltip>
                                                <v-tooltip bottom v-if="!disableAll">
                                                  <v-btn icon v-on="on" color="red" flat @click.prevent="doPromptRemovePerson(row.item)" :loading="policy.loading">
                                                    <v-icon>mdi-delete</v-icon>
                                                  </v-btn>
                                                  <span>{{labels.delPerson}}</span>
                                                </v-tooltip>
                                              </td> -->
                                            </tr>
                                          </template>
                                        </v-data-table>
                                      </v-flex>
                                      <!-- <v-flex xs12>
                                          <v-btn flat color="primary" dark :disabled="disableAll" @click.prevent="doAddPerson" :loading="policy.loading">
                                            <v-icon dark left>mdi-plus-box</v-icon>{{labels.addPerson}}
                                          </v-btn>
                                        </v-flex> -->

                                      <v-flex xs12 v-if="showinsdPersons">
                                        <v-card>
                                          <v-toolbar dense color="grey lighten-5" flat>
                                            <v-icon>mdi-pencil</v-icon>
                                            <v-toolbar-title class="toolbar-title-3">Insured Persons Details </v-toolbar-title>
                                            <v-spacer></v-spacer>
                                          </v-toolbar>
                                          <v-card-text>
                                            <form data-vv-scope="personForm">
                                              <v-container fluid grid-list-lg>
                                                <v-layout row wrap>
                                                  <v-flex lg2 xs12>
                                                    <v-text-field
                                                      v-model="personForm.insdRefNo"
                                                      :label="labels.insdPerRefNo"
                                                      :error-messages="errors.collect('personForm.insdRefNo')"
                                                      data-vv-name="insdRefNo"
                                                      :data-vv-as="labels.insdPerRefNo"
                                                      v-validate="'max:8'"
                                                      readonly
                                                    >
                                                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                                        <v-icon
                                                          color="info"
                                                          @click="doShowInsdRefNo('Person')"
                                                          v-text="'mdi-magnify'"
                                                          :disabled="disableInsdBtn"
                                                        ></v-icon>
                                                      </v-slide-x-reverse-transition>
                                                    </v-text-field>
                                                  </v-flex>
                                                  <v-flex lg2 xs12>
                                                    <v-autocomplete
                                                      :items="salutationList"
                                                      v-model="personForm.titleName"
                                                      :label="labels.titleName"
                                                      item-text="label"
                                                      item-value="value"
                                                      data-vv-name="titleName"
                                                      :data-vv-as="labels.titleName"
                                                      :error-messages="errors.collect('personForm.titleName')"
                                                      v-validate="'max:3'"
                                                      :disabled="disableInsdPerson"
                                                    ></v-autocomplete>
                                                  </v-flex>
                                                  <v-flex lg4 xs12>
                                                    <v-text-field
                                                      v-model="personForm.insdName1"
                                                      :label="labels.insdPerName1"
                                                      :error-messages="errors.collect('personForm.insdName1')"
                                                      data-vv-name="insdName1"
                                                      :data-vv-as="labels.insdPerName1"
                                                      v-validate="'max:60'"
                                                      :disabled="disableInsdPerson"
                                                    ></v-text-field>
                                                  </v-flex>
                                                  <v-flex lg4 xs12>
                                                    <v-text-field
                                                      v-model="personForm.insdName2"
                                                      :label="labels.insdPerName2"
                                                      :error-messages="errors.collect('personForm.insdName2')"
                                                      data-vv-name="insdName2"
                                                      :data-vv-as="labels.insdPerName2"
                                                      v-validate="'max:60'"
                                                      :disabled="disableInsdPerson"
                                                    ></v-text-field>
                                                  </v-flex>
                                                  <v-flex lg4 xs12>
                                                    <v-text-field
                                                      v-model="personForm.icNo"
                                                      :label="labels.icNo"
                                                      :error-messages="errors.collect('personForm.icNo')"
                                                      data-vv-name="icNo"
                                                      :data-vv-as="labels.icNo"
                                                      v-validate="valIcNo"
                                                      :disabled="disableInsdPerson"
                                                    ></v-text-field>
                                                  </v-flex>
                                                  <v-flex lg3 xs12>
                                                    <cal-picker
                                                      v-model="personForm.dob"
                                                      :label="labels.dob"
                                                      v-validate="valDob"
                                                      :data-vv-as="labels.dob"
                                                      data-vv-name="dob"
                                                      :error-messages="errors.collect('personForm.dob')"
                                                      @input="doDob"
                                                      :disabled="disableInsdBtn"
                                                    ></cal-picker>
                                                  </v-flex>
                                                  <v-flex lg1 xs12>
                                                    <v-text-field
                                                      v-model="personForm.age"
                                                      :label="labels.age"
                                                      :error-messages="errors.collect('personForm.age')"
                                                      data-vv-name="age"
                                                      :data-vv-as="labels.age"
                                                      readonly
                                                      :disabled="disableInsdBtn"
                                                    ></v-text-field>
                                                  </v-flex>
                                                  <v-flex lg2 xs12>
                                                    <v-autocomplete
                                                      :items="genderList"
                                                      v-model="personForm.gender"
                                                      :label="labels.gender"
                                                      item-text="label"
                                                      item-value="value"
                                                      data-vv-name="gender"
                                                      :data-vv-as="labels.gender"
                                                      :error-messages="errors.collect('personForm.gender')"
                                                      :disabled="disableInsdBtn"
                                                    ></v-autocomplete>
                                                  </v-flex>
                                                  <v-flex lg2 xs12>
                                                    <v-autocomplete
                                                      :items="maritalStatusList"
                                                      v-model="personForm.mStat"
                                                      :label="labels.mStat"
                                                      item-text="label"
                                                      item-value="value"
                                                      data-vv-name="mStat"
                                                      :data-vv-as="labels.mStat"
                                                      :error-messages="errors.collect('personForm.mStat')"
                                                      :disabled="disableInsdBtn"
                                                    ></v-autocomplete>
                                                  </v-flex>
                                                  <v-flex lg4 xs12>
                                                    <v-autocomplete
                                                      :items="occpList"
                                                      v-model="personForm.occp"
                                                      :label="labels.occp"
                                                      item-text="label"
                                                      item-value="value"
                                                      data-vv-name="occp"
                                                      :data-vv-as="labels.occp"
                                                      :error-messages="errors.collect('personForm.occp')"
                                                      @input="doOccp"
                                                      :disabled="disableInsdBtn"
                                                    ></v-autocomplete>
                                                  </v-flex>
                                                  <v-flex lg8 xs12>
                                                    <v-text-field
                                                      v-model="personForm.occpDesc"
                                                      :label="labels.occpDesc"
                                                      :error-messages="errors.collect('personForm.occpDesc')"
                                                      data-vv-name="occpDesc"
                                                      :data-vv-as="labels.occpDesc"
                                                      v-validate="'max:25'"
                                                      :disabled="disableInsdBtn"
                                                    ></v-text-field>
                                                  </v-flex>
                                                  <v-flex lg4 xs12>
                                                    <v-autocomplete
                                                      :items="relationList"
                                                      v-model="personForm.relation"
                                                      :label="labels.relation"
                                                      item-text="label"
                                                      item-value="value"
                                                      data-vv-name="relation"
                                                      :data-vv-as="labels.relation"
                                                      @input="doRelation"
                                                      :error-messages="errors.collect('personForm.relation')"
                                                      :disabled="disableInsdBtn"
                                                    ></v-autocomplete>
                                                  </v-flex>
                                                  <v-flex lg8 xs12>
                                                    <v-text-field
                                                      v-model="personForm.relationDesc"
                                                      :label="labels.relationDesc"
                                                      :error-messages="errors.collect('personForm.relationDesc')"
                                                      data-vv-name="relationDesc"
                                                      :data-vv-as="labels.relationDesc"
                                                      v-validate="'max:20'"
                                                      :disabled="disableInsdBtn"
                                                    ></v-text-field>
                                                  </v-flex>
                                                  <v-flex xs12>
                                                    <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn depressed @click.prevent="showinsdPersons = false" :disabled="disableInsdBtn"
                                                        ><span class="btn-normal-error">{{ labels.close }}</span></v-btn
                                                      >
                                                      <v-btn depressed type="submit" @click.prevent="doSavePerson" :disabled="disableInsdBtn"
                                                        ><span class="btn-normal-primary">{{ labels.saveInsured }}</span></v-btn
                                                      >
                                                    </v-card-actions>
                                                  </v-flex>
                                                </v-layout>
                                              </v-container>
                                            </form>
                                          </v-card-text>
                                        </v-card>
                                      </v-flex>
                                    </v-layout>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-flex>
                            <v-flex xs12 :class="disableAll ? 'd-none' : ''">
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn depressed @click.prevent="showExpandRiskGrp = false"><span class="btn-normal-error">Close</span></v-btn>
                                <v-btn depressed type="submit" @click.prevent="doProceed('Save')"
                                  ><span class="btn-normal-primary">{{ labels.save }} Risk Group</span></v-btn
                                >
                              </v-card-actions>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn class="mr-2" color="error" dark :loading="policy.loading" @click.prevent="doExit">
                      {{ labels.exit }}
                      <v-icon dark right>mdi-exit-to-app</v-icon>
                    </v-btn>
                    <v-btn class="mr-2" color="primary" dark :loading="policy.loading" @click.prevent="doProceed">
                      {{ labels.proceed }}
                      <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <confirm v-model="promptRemove" @ok="doRemove">{{ deleteTxt }}</confirm>
    <confirm v-model="promptUndoRemoveRiskGrp" @ok="doUndoDelRiskGrp">{{ undoDeleteTxt }}</confirm>
    <confirm v-model="promptRemovePerson" @ok="doRemovePerson">{{ deletePersonTxt }}</confirm>

    <!--Note: Moved all Dialog Box at the bottom-->
    <v-dialog v-model="riskGrpTxtDialog" width="50%" :disabled="disableAll" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-align-justify</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{ labels.riskGrpTxt }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="cancelRiskGrpTxtDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex lg12 xs12>
                <v-tabs v-model="tabMenu">
                  <v-tabs-slider color="primary"></v-tabs-slider>
                  <v-tab ripple>
                    {{ labels.grpUppTxt }}
                  </v-tab>
                  <v-tab ripple>
                    {{ labels.grpLwrTxt }}
                  </v-tab>
                  <v-tab-item>
                    <v-textarea
                      v-model="mainForm.grpUppTxt"
                      :error-messages="errors.collect('grpUppTxt')"
                      data-vv-validate-on="change"
                      data-vv-name="grpUppTxt"
                      :data-vv-as="labels.grpUppTxt"
                      :rows="10"
                    ></v-textarea>
                  </v-tab-item>
                  <v-tab-item>
                    <v-textarea
                      v-model="mainForm.grpLwrTxt"
                      :error-messages="errors.collect('grpLwrTxt')"
                      data-vv-validate-on="change"
                      data-vv-name="grpLwrTxt"
                      :data-vv-as="labels.grpLwrTxt"
                      :rows="10"
                    ></v-textarea>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="cancelRiskGrpTxtDialog"><span class="btn-normal-error">Close</span></v-btn>
          <v-btn depressed @click="saveRiskGrpTxtDialog"
            ><span class="btn-normal-primary">{{ labels.save }}</span></v-btn
          >
          <v-btn depressed @click="doLoadPreset"
            ><span class="btn-normal-primary">{{ labels.loadPreset }}</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="riskGrpPresetDialog" width="80%" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-align-justify</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{ labels.PredefinedTxt }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="riskGrpPresetDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex lg6 xs12>
                <v-autocomplete
                  :items="scrRefList"
                  v-model="scrRef"
                  :label="labels.scrRef"
                  item-text="label"
                  item-value="value"
                  data-vv-name="scrRef"
                  readonly
                ></v-autocomplete>
              </v-flex>
              <v-flex lg6 xs12> </v-flex>
              <v-flex lg6 xs12>
                <v-text-field v-model="polTypeDesc" :label="labels.polType" data-vv-name="polTypeDesc" readonly></v-text-field>
              </v-flex>
              <v-flex lg6 xs12> </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="defTxt.headers"
                  :items="defTxt.items"
                  :loading="loading"
                  :options.sync="defTxt.pagination"
                  class="elevation-1"
                  v-model="defTxt.selected"
                  select-all
                  item-key="txtRef"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row">
                    <tr :active="row.selected" @click="row.selected = !row.selected">
                      <td>
                        <v-checkbox :input-value="row.selected" primary hide-details></v-checkbox>
                      </td>
                      <td>{{ row.item.txtRef }}</td>
                      <td>{{ row.item.txtTitle }}</td>
                      <td>{{ row.item.defTxt }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn depressed @click="riskGrpPresetDialog = false"><span class="btn-normal-error">Close</span></v-btn>
                  <v-btn depressed @click="doSelectTxt"
                    ><span class="btn-normal-primary">{{ labels.select }}</span></v-btn
                  >
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showInsdRefNo" persistent width="1280px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Insured
          <v-spacer></v-spacer>
          <v-btn text icon @click="showInsdRefNo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <form data-vv-scope="queryInsdRefNoFilterForm">
              <v-expansion-panels v-model="panel1" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex lg6 xs12>
                              <v-text-field
                                data-vv-scope="queryInsdRefNoFilterForm"
                                v-model="filters.insdRefNo"
                                :label="filtersLabel.insdRefNo"
                                :error-messages="errors.collect('filterInsdRefNo')"
                                data-vv-name="filterInsdRefNo"
                                :data-vv-as="filtersLabel.insdRefNo"
                                v-validate="'entry|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg6 xs12>
                              <v-text-field
                                data-vv-scope="queryInsdRefNoFilterForm"
                                v-model="filters.name1"
                                :label="filtersLabel.name1"
                                :error-messages="errors.collect('filterName1')"
                                data-vv-name="filterName1"
                                :data-vv-as="filtersLabel.name1"
                                v-validate="'name|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg6 xs12>
                              <v-text-field
                                data-vv-scope="queryInsdRefNoFilterForm"
                                v-model="filters.icNo"
                                :label="filtersLabel.icNo"
                                :error-messages="errors.collect('filterIcNo')"
                                data-vv-name="filterIcNo"
                                :data-vv-as="filtersLabel.icNo"
                                v-validate="'name|max:20'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions right>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-data-table
              :headers="insured.insuredHeaders"
              :items="insured.insuredItems"
              :options.sync="pagination"
              :footer-props="{ 'items-per-page-options': itemsPerPage }"
              :server-items-length="totalItems"
              :loading="loading"
              class="elevation-1"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.insdRefNo }}</td>
                  <td>{{ row.item.name1 }}</td>
                  <td>{{ row.item.icNo }}</td>
                  <td style="margin: 0 auto">
                    <v-btn icon color="primary" text type="submit" @click.prevent="doSelectInsdRefNo(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="policy.loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="promptSelectRiskGrp" persistent width="400px">
      <v-card>
        <v-card-text> Please select Risk No. in Risk Details and click Endorse. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="closeDialog"> OK </v-btn>
          <v-btn color="red" text @click.native="promptSelectRiskGrp = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatYesNo } from '@/utils/boolean'
import { yearDiff } from '@/utils/date'
import {
  POLICY_RISK_GROUP,
  POLICY_RISK_TAB,
  POLICY_SELECTED_RISKGRPNO,
  POLICY_SELECTED_PLANNO,
  POLICY_LIFECYCLE,
  POLICY_HEADER_TAB
} from '@/store/types'
import { salutation, gender, maritalStatus } from '@/const/underwriting'
import { toDate, parseISO } from 'date-fns'
import { isEqual } from '@/utils/compare'

export default {
  data() {
    return {
      showExpandRiskGrp: true,
      showExpandSubDet: false,
      showExpandInsured: false,
      labels: {
        endorseTitle: 'Select Risk(s) for Endorsement',
        mainTitle: 'Policy Risk Groups',
        tableTitle: 'Plan List',
        addGroup: 'Add Group',
        updateGroup: 'Update Group',
        delRiskGrp: 'Delete Group',
        riskGrpNo: 'Risk Group',
        riskGrpDetail: 'Risk Group Text',
        noDay: 'No. of Days',
        planNo: 'Plan No.',
        noAdult: 'No. of Adults',
        riskGrpTxt: 'Risk Group Text',
        noChild: 'No. of Children',
        noLive: 'No. of Lives',
        PredefinedTxt: 'Predefined Text',
        grpUppTxt: 'Upper Text',
        grpLwrTxt: 'Lower Text',
        loadPreset: 'Load Preset',
        subTitle: 'Subsidiary Details',
        insdRefNo: 'Risk Group Reference',
        titleName: 'Salutation',
        insdName1: 'Name 1',
        insdName2: 'Name 2',
        mailAdd: 'Same as Mailing Address',
        insdAddr1: 'Block / House No.',
        insdAddr2: 'Unit No',
        insdAddr3: 'Street Name',
        insdAddr4: 'Building Name',
        insdAddr5: 'State',
        insdAddr6: 'Country',
        postCode: 'Post Code',
        scrRef: 'Screen Reference No.',
        polType: 'Policy Type',
        insdPersonsTitle: 'Insured Persons',
        updatePerson: 'Update Insured',
        delPerson: 'Delete Insured',
        addPerson: 'Add Insured',
        insdPerRefNo: 'Insured Reference',
        insdPerName1: 'Name 1 as in NRIC / Passport',
        insdPerName2: 'Name 2 as in NRIC / Passport',
        icNo: 'NRIC / Passport No.',
        dob: 'Date of Birth',
        age: 'Age',
        gender: 'Gender',
        mStat: 'Marital Status',
        occp: 'Occupation',
        occpDesc: 'Occupation Description',
        relation: 'Relationship',
        relationDesc: 'Relationship Description',
        exit: 'Exit',
        reset: 'Reset',
        save: 'Save',
        proceed: 'Proceed',
        select: 'Select',
        insdPremises: 'Premises',
        addNewGroup: 'New Group',
        addNewRisk: 'New Risk',
        endorse: 'Endorse',
        cancel: 'Cancel',
        close: 'Close',
        saveInsured: 'Save Insured',
        saveSub: 'Save Subsidiary'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        delRiskGrp: undefined,
        noDay: undefined,
        planNo: '',
        noAdult: undefined,
        noChild: undefined,
        noLive: undefined,
        grpUppTxt: undefined,
        grpLwrTxt: undefined,
        grpMemo: undefined,
        grpStdTxt: undefined,
        insdRefNo: '',
        titleName: '',
        insdName1: '',
        insdName2: '',
        insdName3: '',
        insdAddr1: '',
        insdAddr2: '',
        insdAddr3: '',
        insdAddr4: '',
        insdAddr5: '',
        insdAddr6: '',
        postCode: '',
        insdName4: '',
        mailAdd: undefined,
        insdPremises: ''
      },
      riskGrpTxtForm: {
        grpUppTxt: undefined,
        grpLwrTxt: undefined
      },
      headers: [
        { text: 'Risk Group', align: 'left', value: 'riskGrpNo' },
        { text: 'Plan', align: 'left', value: 'plan' },
        { text: 'No. of Days', value: 'noDay' },
        { text: 'No. of Adults', value: 'noAdult' },
        { text: 'No. of Children', value: 'noChild' },
        { text: 'No. of Lives', value: 'noLive' },
        { text: 'Del Group', value: 'delRiskGrp' },
        { text: 'Action', value: 'action', align: 'center' }
      ],
      policy: {
        loading: false
      },
      loading: false,
      disableAll: undefined,
      pkgPlanList: [],
      dEffDate: undefined,
      polRiskGrp: [],
      selectedGroup: undefined,
      promptRemove: false,
      deleteTxt: '',
      promptUndoRemoveRiskGrp: false,
      undoDeleteTxt: '',
      riskGrpTxtDialog: false,
      riskGrpPresetDialog: false,
      defTxt: {
        headers: [
          { text: 'Text Ref No.', value: 'txtRef' },
          { text: 'text Title', value: 'txtTitle' },
          { text: 'Default Text', value: 'defTxt' }
        ],
        items: [],
        itemsUpperTxt: [],
        itemsLowerTxt: [],
        pagination: {
          itemsPerPage: -1
        },
        selected: [],
        selectedUpperTxt: [],
        selectedLowerTxt: [],
        displayUpperTxt: undefined,
        displayLowerTxt: undefined
      },
      tabMenu: null,
      allowSubDet: undefined,
      allowInsd: undefined,
      countryList: [],
      postalCodList: [],
      showInsdRefNo: false,
      insuredOrPerson: undefined,
      filtersLabel: {
        insdRefNo: 'Insured Ref No.',
        name1: 'Name',
        icNo: 'IC No.'
      },
      filters: {
        insdRefNo: undefined,
        name1: undefined,
        icNo: undefined
      },
      insured: {
        insuredHeaders: [
          { text: 'Insured Ref No.', align: 'left', value: 'insdRefNo' },
          { text: 'Name', value: 'name1' },
          { text: 'IC No.', value: 'icNo' },
          { text: 'Action', align: 'center', sortable: false, value: '' }
        ],
        insuredItems: []
      },
      totalItems: 0,
      disableInsured: false,
      person: {
        personHeaders: [
          { text: 'Insured Ref No.', align: 'left', value: 'insdRefNo' },
          { text: 'Name as in NRIC / Passport', value: 'insdName1' },
          { text: 'NRIC No.', value: 'icNo' },
          { text: 'Date of Birth', value: 'dob' },
          { text: 'Age', value: 'age' },
          { text: 'Action', align: 'center', sortable: false, value: '' }
        ],
        personItems: []
      },
      disableInsdPerson: true,
      disableInsdBtn: true,
      personForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        seqNo: undefined,
        insdRefNo: undefined,
        titleName: undefined,
        insdName1: undefined,
        insdName2: undefined,
        icNo: undefined,
        dob: undefined,
        age: undefined,
        gender: undefined,
        mStat: undefined,
        occp: undefined,
        occpDesc: undefined,
        relation: undefined,
        relationDesc: undefined
      },
      resetPersonForm: {
        riskGrpNo: undefined,
        seqNo: undefined,
        insdRefNo: undefined,
        titleName: undefined,
        insdName1: undefined,
        insdName2: undefined,
        icNo: undefined,
        dob: undefined,
        age: undefined,
        gender: undefined,
        mStat: undefined,
        occp: undefined,
        occpDesc: undefined,
        relation: undefined,
        relationDesc: undefined
      },
      occpList: [],
      relationList: [],
      selectedPerson: undefined,
      promptRemovePerson: false,
      deletePersonTxt: '',
      scrRefList: [
        { value: '10', label: 'Risk Group Upper Text' },
        { value: '11', label: 'Risk Group Lower Text' }
      ],
      scrRef: undefined,
      polTypeDesc: undefined,
      riskList: [],
      riskHeaders: [
        { text: 'Risk No', align: 'left', value: 'riskGrpNoRiskNo' },
        { text: 'Class', value: 'busClsDesc' },
        { text: 'SI Currency', value: 'siCurr' },
        { text: 'SI Currency Rate', value: 'siExRate' },
        { text: 'Sum Insured', value: 'si' },
        { text: '', value: 'action', align: 'center' }
      ],
      riskSelected: [],
      endorseRiskList: [],
      endorseForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        prevPolNo: undefined,
        prevRenCnt: undefined,
        prevEndtCnt: undefined,
        riskGrpNo: [],
        riskNo: []
      },
      showErrorDialog: false,
      showinsdPersons: false,
      promptSelectRiskGrp: false,
      disablePlan: undefined, // 2020-10-06  LYT OS-495
      prevEndtCntAvail: undefined, // 2020-10-06  LYT OS-495
      isPkgPlanScheme: undefined,
      pagination: {
        sortDesc: [false],
        page: 1
      },
      panel1: [0]
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    pagination: function (value) {
      this.fetchData()
    },
    'personForm.insdRefNo': function (value) {
      if (value !== '') {
        this.disableInsdPerson = true
      } else {
        this.disableInsdPerson = false
      }
    },
    'personForm.seqNo': function (value) {
      if (value === undefined) {
        this.disableInsdBtn = true
        // this.disableInsdPerson = true //2020-10-05 LYT OS-496
      } else {
        this.disableInsdBtn = false
        // this.disableInsdPerson = false //2020-10-05 LYT OS-496
      }
    },
    'mainForm.riskGrpNo': function (value) {
      this.$store.commit(POLICY_SELECTED_RISKGRPNO, value)
    },
    'mainForm.planNo': function (value) {
      this.$store.commit(POLICY_SELECTED_PLANNO, value)
    },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    policyInfo() {
      return this.$store.state.underwriting.policy.policyInfo
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    valInsd() {
      if (this.mainForm.insdRefNo !== '') {
        return 'required|max:60'
      } else {
        return 'max:60'
      }
    },
    valCtyPc() {
      if (this.mainForm.insdRefNo !== '') {
        return 'required'
      } else {
        return undefined
      }
    },
    valPostcode() {
      if (this.mainForm.insdRefNo !== '') {
        return 'required'
      } else {
        return undefined
      }
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maritalStatusList() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    valIcNo() {
      if (this.mainForm.insdRefNo !== '') {
        return 'required|max:20'
      } else {
        return 'max:20'
      }
    },
    valDob() {
      if (this.mainForm.insdRefNo !== '') {
        return 'required'
      } else {
        return ''
      }
    },
    getOccpDesc() {
      return this.occpList.filter((occp) => {
        return occp.value === this.personForm.occp
      })
    },
    getRelationDesc() {
      return this.relationList.filter((relation) => {
        return relation.value === this.personForm.relation
      })
    },
    displayErrorDialog() {
      return this.messages
    },
    getSelectedRiskGrp() {
      return this.items.filter((item) => {
        return item.riskGrpNo === this.mainForm.riskGrpNo
      })
    }
  },
  methods: {
    doInit() {
      this.tab = 0
      this.mainForm.polNo = this.polMaster.polNo
      this.mainForm.renCnt = this.polMaster.renCnt
      this.mainForm.endtCnt = this.polMaster.endtCnt
      this.mainForm.grpMemo = ''
      this.mainForm.grpStdTxt = ''
      this.polTypeDesc = this.policyInfo.polTypeDesc
      this.$set(this, 'items', [])
      this.showinsdPersons = false

      // if (this.polMaster.scheme === undefined || this.polMaster.scheme === '') {
      //   this.disableAll = true
      // } else {
      //   this.getPkgPlanList()
      // }
      this.getPkgPlanList().then(() => {
        this.getPlanList().then(() => {
          if (this.polMaster.tranType === 'E' && this.endorseRiskList.length > 0) {
            // YY: SonarLint Issue 21-Apr-20
          } else if (this.items) {
            this.mainForm.riskGrpNo = this.items[0].riskGrpNo
            this.mainForm.noDay = this.items[0].noDay
            this.mainForm.planNo = this.items[0].planNo
            this.mainForm.noAdult = this.items[0].noAdult
            this.mainForm.noChild = this.items[0].noChild
            this.mainForm.noLive = this.items[0].noLive
            this.mainForm.insdPremises = this.items[0].insdPremises
            if (this.items[0].delRiskGrp === 'YES') {
              this.mainForm.delRiskGrp = true
            } else {
              this.mainForm.delRiskGrp = false
            }
            this.mainForm.insdRefNo = this.toStringEmpty(this.items[0].insdRefNo)
            this.mainForm.titleName = this.toStringEmpty(this.items[0].titleName)
            this.mainForm.insdName1 = this.toStringEmpty(this.items[0].insdName1)
            this.mainForm.insdName2 = this.toStringEmpty(this.items[0].insdName2)
            this.mainForm.insdAddr1 = this.toStringEmpty(this.items[0].insdAddr1)
            this.mainForm.insdAddr2 = this.toStringEmpty(this.items[0].insdAddr2)
            this.mainForm.insdAddr3 = this.toStringEmpty(this.items[0].insdAddr3)
            this.mainForm.insdAddr4 = this.toStringEmpty(this.items[0].insdAddr4)
            this.mainForm.insdAddr5 = this.toStringEmpty(this.items[0].insdAddr5)
            this.mainForm.insdAddr6 = this.toStringEmpty(this.items[0].insdAddr6)
            this.mainForm.postCode = this.toStringEmpty(this.items[0].postCode)
            this.mainForm.grpUppTxt = this.toStringEmpty(this.items[0].grpUppTxt)
            this.mainForm.grpLwrTxt = this.toStringEmpty(this.items[0].grpLwrTxt)
            this.copymainForm = clone(this.mainForm)
          }

          if (this.allowInsd === true) {
            if (this.mainForm.riskGrpNo) {
              this.getPolInsdDetList()
            }
          }
        })
      })
    },
    async getPlanList() {
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.planList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          const { data } = result
          if (this.polMaster.tranType === 'E') {
            // Endorsement
            if (data) {
              this.endorseRiskList = []
              data.data.map((endorseRisk) => {
                const convertEndorseRisk = {
                  polNo: endorseRisk.polNo,
                  renCnt: endorseRisk.renCnt,
                  endtCnt: endorseRisk.endtCnt
                }
                this.endorseRiskList.push(convertEndorseRisk)
              })

              if (this.endorseRiskList[0].endtCnt === null || this.endorseRiskList[0].endtCnt === undefined) {
                this.endorseRiskList = []
              }
              if (this.endorseRiskList.length === 0) {
                // Review Endorsement List
                this.displayItemList(data)
              } else {
                // Select Endorsement List
                this.riskList = []
                data.data.map((risk) => {
                  const convertRisk = {
                    polNo: risk.polNo,
                    renCnt: risk.renCnt,
                    endtCnt: risk.endtCnt,
                    riskGrpNoRiskNo: risk.riskGrpNo.toString().padStart(2, '0') + '/' + risk.riskNo.toString().padStart(3, '0'),
                    riskGrpNo: risk.riskGrpNo.toString().padStart(2, '0'),
                    riskNo: risk.riskNo.toString().padStart(3, '0'),
                    busCls: risk.busCls,
                    busClsDesc: risk.busCls + ' - ' + risk.busClsDesc,
                    siCurr: risk.siCurr,
                    siExRate: risk.siExRate.toFixed(7),
                    comDate: risk.comDate,
                    comDateFormat: this.formatDate(risk.comDate),
                    expDate: risk.expDate,
                    expDateFormat: this.formatDate(risk.expDate),
                    delRisk: formatYesNo(risk.delRisk),
                    indGrp: risk.indGrp,
                    stdRiskTxtRef: risk.stdRiskTxtRef,
                    riskUppTxt: risk.riskUppTxt,
                    riskLwrTxt: risk.riskLwrTxt,
                    canFindPkgPlan: risk.canFindPkgPlan,
                    newRiskNo: risk.newRiskNo,
                    si: risk.si
                  }
                  this.riskList.push(convertRisk)
                })
                this.loading = false
              }
            } else {
              this.riskList = []
              this.loading = false
            }
          } else {
            this.displayItemList(data)
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.copymainForm = clone(this.mainForm)
    },
    async getPkgPlanList() {
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.polRiskGroupParam
      if (apiUrl) {
        try {
          if (this.polMaster.comDate !== undefined && this.polMaster.comDate !== null) {
            this.dEffDate = new Date(this.polMaster.comDate)
          } else if (this.polMaster.endtDate !== undefined && this.polMaster.endtDate !== null) {
            this.dEffDate = new Date(this.polMaster.endtDate)
          } else {
            this.dEffDate = new Date(this.polMaster.tranDate)
          }
          const expand = {
            polType: this.polMaster.polType,
            scheme: this.polMaster.scheme,
            effDate: this.dEffDate,
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data.pkgPlanList) {
            this.$set(this, 'pkgPlanList', result.data.pkgPlanList)
          }

          if (result.data.upperTxtList) {
            const { data } = result.data.upperTxtList
            let uppText = ''
            if (data) {
              this.defTxt.itemsUpperTxt = []
              this.defTxt.selectedUpperTxt = []
              let displayUpperTxt = []
              data.map((upperText) => {
                const convertUpperText = {
                  txtRef: upperText.txtRef,
                  txtTitle: upperText.txtTitle,
                  defTxt: upperText.defTxt
                }
                this.defTxt.itemsUpperTxt.push(convertUpperText)
                if (upperText.txtDef === true) {
                  this.defTxt.selectedUpperTxt.push(convertUpperText)
                  displayUpperTxt.push(convertUpperText.defTxt + '\n')
                }
              })
              for (let uT in displayUpperTxt) {
                uppText += displayUpperTxt[uT]
              }
              this.defTxt.displayUpperTxt = uppText
            } else {
              this.defTxt.itemsUpperTxt = undefined
            }
          }

          if (result.data.lowerTxtList) {
            const { data } = result.data.lowerTxtList
            let lwrText = ''
            if (data) {
              this.defTxt.itemsLowerTxt = []
              this.defTxt.selectedLowerTxt = []
              let displayLowerTxt = []
              data.map((lowerText) => {
                const convertLowerText = {
                  txtRef: lowerText.txtRef,
                  txtTitle: lowerText.txtTitle,
                  defTxt: lowerText.defTxt
                }
                this.defTxt.itemsLowerTxt.push(convertLowerText)
                if (lowerText.txtDef === true) {
                  this.defTxt.selectedLowerTxt.push(convertLowerText)
                  displayLowerTxt.push(convertLowerText.defTxt + '\n')
                }
              })
              for (let lT in displayLowerTxt) {
                lwrText += displayLowerTxt[lT]
              }
              this.defTxt.displayLowerTxt = lwrText
            } else {
              this.defTxt.itemsLowerTxt = undefined
            }
          }

          if (result.data.isoCountryList) {
            this.$set(this, 'countryList', result.data.isoCountryList)
          }

          if (result.data.occupationList) {
            this.$set(this, 'occpList', result.data.occupationList)
          }

          if (result.data.relationshipList) {
            this.$set(this, 'relationList', result.data.relationshipList)
          }

          this.prevEndtCntAvail = result.data.prevEndtCntAvail
          // AR: 26Jan2021 OS-657
          // if (result.data.isPkgScheme === true) {
          // if (result.data.isPlanPkgScheme === true) {
          // 2021-02-26 LYT OS-657
          this.isPkgPlanScheme = result.data.isPkgPlanScheme
          if (result.data.isPkgPlanScheme === true) {
            this.disableAll = false

            // 2020-10-06 LYT OS-495
            this.checkPlan()
            this.allowSubDet = result.data.allowSubDet
          } else {
            this.disableAll = true

            // 2020-10-06 LYT OS-495
            this.allowSubDet = false
            this.disablePlan = true
          }
          this.allowInsd = result.data.allowInsd
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doSelect(data) {
      this.showExpandRiskGrp = true
      this.policy.loading = true
      this.mainForm.riskGrpNo = data.riskGrpNo
      this.mainForm.noDay = data.noDay
      this.mainForm.planNo = data.planNo
      this.mainForm.noAdult = data.noAdult
      this.mainForm.noChild = data.noChild
      this.mainForm.noLive = data.noLive
      this.mainForm.insdPremises = data.insdPremises
      if (data.delRiskGrp === 'YES') {
        this.mainForm.delRiskGrp = true
      } else {
        this.mainForm.delRiskGrp = false
      }
      this.mainForm.insdRefNo = this.toStringEmpty(data.insdRefNo)
      this.mainForm.titleName = this.toStringEmpty(data.titleName)
      this.mainForm.insdName1 = this.toStringEmpty(data.insdName1)
      this.mainForm.insdName2 = this.toStringEmpty(data.insdName2)
      this.mainForm.insdAddr1 = this.toStringEmpty(data.insdAddr1)
      this.mainForm.insdAddr2 = this.toStringEmpty(data.insdAddr2)
      this.mainForm.insdAddr3 = this.toStringEmpty(data.insdAddr3)
      this.mainForm.insdAddr4 = this.toStringEmpty(data.insdAddr4)
      this.mainForm.insdAddr5 = this.toStringEmpty(data.insdAddr5)
      this.mainForm.insdAddr6 = this.toStringEmpty(data.insdAddr6)
      this.mainForm.postCode = this.toStringEmpty(data.postCode)
      this.mainForm.grpUppTxt = this.toStringEmpty(data.grpUppTxt)
      this.mainForm.grpLwrTxt = this.toStringEmpty(data.grpLwrTxt)
      if (this.mainForm.riskGrpNo) {
        this.getPolInsdDetList()
      }
      this.copymainForm = clone(this.mainForm)
      this.policy.loading = false
    },
    async doPromptRemove(data) {
      this.selectedGroup = data
      this.deleteTxt = 'Confirm to Delete Risk Group ' + data.riskGrpNo
      this.promptRemove = true
    },
    doPromptUndoDelRiskGrp(data) {
      this.selectedGroup = data
      this.undoDeleteTxt = 'Confirm to undo delete Group No. ' + data.riskGrpNo + '?'
      this.promptUndoRemoveRiskGrp = true
    },
    async doRemove(data) {
      this.policy.loading = true
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.delGroup
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.selectedGroup.riskGrpNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result) {
            const { data } = result
            if (data) {
              this.mainForm.planNo = ''
              this.items = []
              data.data.map((plan) => {
                const convertPlan = {
                  riskGrpNo: plan.riskGrpNo,
                  planNo: plan.planNo,
                  planDesc: plan.planDesc,
                  noDay: plan.noDay,
                  noAdult: plan.noAdult,
                  noChild: plan.noChild,
                  noLive: plan.noLive,
                  insdPremises: plan.insdPremises,
                  delRiskGrp: formatYesNo(plan.delRiskGrp),
                  insdRefNo: plan.insdRefNo,
                  titleName: plan.titleName,
                  insdName1: plan.insdName1,
                  insdName2: plan.insdName2,
                  insdAddr1: plan.insdAddr1,
                  insdAddr2: plan.insdAddr2,
                  insdAddr3: plan.insdAddr3,
                  insdAddr4: plan.insdAddr4,
                  insdAddr5: plan.insdAddr5,
                  insdAddr6: plan.insdAddr6,
                  postCode: plan.postCode,
                  grpUppTxt: plan.grpUppTxt,
                  grpLwrTxt: plan.grpLwrTxt
                }
                this.items.push(convertPlan)
                this.mainForm.riskGrpNo = this.items[0].riskGrpNo
                this.mainForm.noDay = this.items[0].noDay
                this.mainForm.planNo = this.items[0].planNo
                this.mainForm.noAdult = this.items[0].noAdult
                this.mainForm.noChild = this.items[0].noChild
                this.mainForm.noLive = this.items[0].noLive
                this.mainForm.insdPremises = this.items[0].insdPremises
                if (this.items[0].delRiskGrp === 'YES') {
                  this.mainForm.delRiskGrp = true
                } else {
                  this.mainForm.delRiskGrp = false
                }
                this.mainForm.insdRefNo = this.toStringEmpty(this.items[0].insdRefNo)
                this.mainForm.titleName = this.toStringEmpty(this.items[0].titleName)
                this.mainForm.insdName1 = this.toStringEmpty(this.items[0].insdName1)
                this.mainForm.insdName2 = this.toStringEmpty(this.items[0].insdName2)
                this.mainForm.insdAddr1 = this.toStringEmpty(this.items[0].insdAddr1)
                this.mainForm.insdAddr2 = this.toStringEmpty(this.items[0].insdAddr2)
                this.mainForm.insdAddr3 = this.toStringEmpty(this.items[0].insdAddr3)
                this.mainForm.insdAddr4 = this.toStringEmpty(this.items[0].insdAddr4)
                this.mainForm.insdAddr5 = this.toStringEmpty(this.items[0].insdAddr5)
                this.mainForm.insdAddr6 = this.toStringEmpty(this.items[0].insdAddr6)
                this.mainForm.postCode = this.toStringEmpty(this.items[0].postCode)
                this.mainForm.grpUppTxt = this.toStringEmpty(this.items[0].grpUppTxt)
                this.mainForm.grpLwrTxt = this.toStringEmpty(this.items[0].grpLwrTxt)
                if (this.mainForm.riskGrpNo) {
                  this.getPolInsdDetList()
                }
              })
            } else {
              this.items = []
            }
            this.policy.loading = false
            this.$toast.success('Risk Group Deleted Successfully')
          }
        } catch (err) {
          this.policy.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      }
      this.policy.loading = false
    },
    // 2020-10-06 LYT OS-495
    async doUndoDelRiskGrp(data) {
      this.policy.loading = true
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.undoDelGroup
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.selectedGroup.riskGrpNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result) {
            const { data } = result
            if (data) {
              this.items = []
              data.data.map((plan) => {
                const convertPlan = {
                  riskGrpNo: plan.riskGrpNo,
                  planNo: plan.planNo,
                  planDesc: plan.planDesc,
                  noDay: plan.noDay,
                  noAdult: plan.noAdult,
                  noChild: plan.noChild,
                  noLive: plan.noLive,
                  insdPremises: plan.insdPremises,
                  delRiskGrp: formatYesNo(plan.delRiskGrp),
                  insdRefNo: plan.insdRefNo,
                  titleName: plan.titleName,
                  insdName1: plan.insdName1,
                  insdName2: plan.insdName2,
                  insdAddr1: plan.insdAddr1,
                  insdAddr2: plan.insdAddr2,
                  insdAddr3: plan.insdAddr3,
                  insdAddr4: plan.insdAddr4,
                  insdAddr5: plan.insdAddr5,
                  insdAddr6: plan.insdAddr6,
                  postCode: plan.postCode,
                  grpUppTxt: plan.grpUppTxt,
                  grpLwrTxt: plan.grpLwrTxt
                }
                this.items.push(convertPlan)
                this.mainForm.riskGrpNo = this.items[0].riskGrpNo
                this.mainForm.noDay = this.items[0].noDay
                this.mainForm.planNo = this.items[0].planNo
                this.mainForm.noAdult = this.items[0].noAdult
                this.mainForm.noChild = this.items[0].noChild
                this.mainForm.noLive = this.items[0].noLive
                this.mainForm.insdPremises = this.items[0].insdPremises
                if (this.items[0].delRiskGrp === 'YES') {
                  this.mainForm.delRiskGrp = true
                } else {
                  this.mainForm.delRiskGrp = false
                }
                this.mainForm.insdRefNo = this.toStringEmpty(this.items[0].insdRefNo)
                this.mainForm.titleName = this.toStringEmpty(this.items[0].titleName)
                this.mainForm.insdName1 = this.toStringEmpty(this.items[0].insdName1)
                this.mainForm.insdName2 = this.toStringEmpty(this.items[0].insdName2)
                this.mainForm.insdAddr1 = this.toStringEmpty(this.items[0].insdAddr1)
                this.mainForm.insdAddr2 = this.toStringEmpty(this.items[0].insdAddr2)
                this.mainForm.insdAddr3 = this.toStringEmpty(this.items[0].insdAddr3)
                this.mainForm.insdAddr4 = this.toStringEmpty(this.items[0].insdAddr4)
                this.mainForm.insdAddr5 = this.toStringEmpty(this.items[0].insdAddr5)
                this.mainForm.insdAddr6 = this.toStringEmpty(this.items[0].insdAddr6)
                this.mainForm.postCode = this.toStringEmpty(this.items[0].postCode)
                this.mainForm.grpUppTxt = this.toStringEmpty(this.items[0].grpUppTxt)
                this.mainForm.grpLwrTxt = this.toStringEmpty(this.items[0].grpLwrTxt)
                if (this.mainForm.riskGrpNo) {
                  this.getPolInsdDetList()
                }
              })
            } else {
              this.items = []
            }
            this.policy.loading = false
            this.$toast.success('Risk Group Undo Successfully')
          }
        } catch (err) {
          this.policy.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      }
      this.policy.loading = false
    },
    async doAddGroup() {
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.addGroup
      if (apiUrl) {
        try {
          this.policy.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result) {
            const { data } = result
            if (data) {
              data.data.map((plan) => {
                const convertPlan = {
                  riskGrpNo: plan.riskGrpNo,
                  planNo: plan.planNo,
                  planDesc: plan.planDesc,
                  noDay: plan.noDay,
                  noAdult: plan.noAdult,
                  noChild: plan.noChild,
                  noLive: plan.noLive,
                  insdPremises: plan.insdPremises,
                  delRiskGrp: formatYesNo(plan.delRiskGrp),
                  insdRefNo: plan.insdRefNo,
                  titleName: plan.titleName,
                  insdName1: plan.insdName1,
                  insdName2: plan.insdName2,
                  insdAddr1: plan.insdAddr1,
                  insdAddr2: plan.insdAddr2,
                  insdAddr3: plan.insdAddr3,
                  insdAddr4: plan.insdAddr4,
                  insdAddr5: plan.insdAddr5,
                  insdAddr6: plan.insdAddr6,
                  postCode: plan.postCode,
                  grpUppTxt: plan.grpUppTxt,
                  grpLwrTxt: plan.grpLwrTxt
                }
                this.items.push(convertPlan)
                const row = this.items.length - 1
                this.mainForm.riskGrpNo = this.items[row].riskGrpNo
                this.mainForm.noDay = this.items[row].noDay
                this.mainForm.planNo = this.items[row].planNo
                this.mainForm.noAdult = this.items[row].noAdult
                this.mainForm.noChild = this.items[row].noChild
                this.mainForm.noLive = this.items[row].noLive
                this.mainForm.insdPremises = this.items[row].insdPremises
                if (this.items[row].delRiskGrp === 'YES') {
                  this.mainForm.delRiskGrp = true
                } else {
                  this.mainForm.delRiskGrp = false
                }
                this.mainForm.insdRefNo = this.toStringEmpty(this.items[row].insdRefNo)
                this.mainForm.titleName = this.toStringEmpty(this.items[row].titleName)
                this.mainForm.insdName1 = this.toStringEmpty(this.items[row].insdName1)
                this.mainForm.insdName2 = this.toStringEmpty(this.items[row].insdName2)
                this.mainForm.insdAddr1 = this.toStringEmpty(this.items[row].insdAddr1)
                this.mainForm.insdAddr2 = this.toStringEmpty(this.items[row].insdAddr2)
                this.mainForm.insdAddr3 = this.toStringEmpty(this.items[row].insdAddr3)
                this.mainForm.insdAddr4 = this.toStringEmpty(this.items[row].insdAddr4)
                this.mainForm.insdAddr5 = this.toStringEmpty(this.items[row].insdAddr5)
                this.mainForm.insdAddr6 = this.toStringEmpty(this.items[row].insdAddr6)
                this.mainForm.postCode = this.toStringEmpty(this.items[row].postCode)
                this.mainForm.grpUppTxt = this.toStringEmpty(this.items[row].grpUppTxt)
                this.mainForm.grpLwrTxt = this.toStringEmpty(this.items[row].grpLwrTxt)
                if (this.mainForm.riskGrpNo) {
                  this.getPolInsdDetList()
                }
              })
            } else {
              this.items = []
            }
            this.policy.loading = false
            this.showExpandRiskGrp = true
            this.copymainForm = clone(this.mainForm)
          }
        } catch (err) {
          this.policy.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doProceed(caller) {
      if (caller === 'RiskGroupTxt') {
        this.policy.loading = true
        this.doPolRiskGrpSave().then((success) => {
          if (success) {
            this.displayPlanList()
            this.$toast.success('Risk group text successfully saved.')
          } else {
            this.$toast.error('An unexpected error occured while saving risk group text.')
          }
          this.policy.loading = false
        })
      } else {
        this.resetMessages()
        if (this.showinsdPersons === true) {
          this.$validator.validateAll('personForm').then((result1) => {
            if (result1) {
              this.$validator.validateAll().then((result) => {
                if (result) {
                  this.policy.loading = true
                  this.personForm.polNo = this.polMaster.polNo
                  this.personForm.renCnt = this.polMaster.renCnt
                  this.personForm.endtCnt = this.polMaster.endtCnt
                  this.personForm.riskGrpNo = this.mainForm.riskGrpNo
                  this.doPolInsdSave().then((success1) => {
                    if (success1) {
                      this.doPolRiskGrpSave().then((success) => {
                        if (success) {
                          if (caller === 'Save') {
                            this.displayPlanList()
                            this.$toast.success('Policy record successfully saved.')
                          } else {
                            this.$store.commit(POLICY_RISK_TAB, 1)
                            this.$router.push({ name: 'policyRiskDetails' })
                          }
                        } else {
                          this.$toast.error('An unexpected error occured while saving policy record.')
                        }
                        this.policy.loading = false
                      })
                    } else {
                      this.$toast.error('Insured Person Details Failed')
                    }
                    // this.policy.loading = false
                  })
                } else {
                  if (caller !== 'Save') {
                    this.$parent.$parent.changeTab(0)
                  }
                  this.promptFieldCheck()
                }
              })
            } else {
              if (caller !== 'Save') {
                this.$parent.$parent.changeTab(0)
              }
              this.promptFieldCheck()
            }
          })
        } else {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.policy.loading = true
              this.doPolRiskGrpSave().then((success) => {
                if (success) {
                  if (caller === 'Save') {
                    this.displayPlanList()
                    this.$toast.success('Policy record successfully saved.')
                  } else {
                    this.$store.commit(POLICY_RISK_TAB, 1)
                    this.$router.push({ name: 'policyRiskDetails' })
                  }
                } else {
                  this.$toast.error('An unexpected error occured while saving policy record.')
                }
                this.policy.loading = false
              })
            } else {
              this.promptFieldCheck()
            }
          })
        }
      }
    },
    async doPolRiskGrpSave() {
      try {
        if (this.mainForm.planNo === undefined) {
          this.mainForm.planNo = ''
          this.copymainForm.planNo = ''
        }
        this.$store.commit(POLICY_RISK_GROUP, this.mainForm)
        if (isEqual(this.mainForm, this.copymainForm) === true) {
          return true
        } else {
          const result = await this.$store.dispatch('savePolRiskGroup', this.mainForm)
          if (result) {
            this.copymainForm = clone(this.mainForm)
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    },
    displayPlanList() {
      this.items = []
      if (this.polMaster.polRiskGrps) {
        this.polMaster.polRiskGrps.map((plan) => {
          const convertPlan = {
            riskGrpNo: plan.riskGrpNo,
            planNo: plan.planNo,
            planDesc: plan.planDesc,
            noDay: plan.noDay,
            noAdult: plan.noAdult,
            noChild: plan.noChild,
            noLive: plan.noLive,
            insdPremises: plan.insdPremises,
            delRiskGrp: formatYesNo(plan.delRiskGrp),
            insdRefNo: plan.insdRefNo,
            titleName: plan.titleName,
            insdName1: plan.insdName1,
            insdName2: plan.insdName2,
            insdAddr1: plan.insdAddr1,
            insdAddr2: plan.insdAddr2,
            insdAddr3: plan.insdAddr3,
            insdAddr4: plan.insdAddr4,
            insdAddr5: plan.insdAddr5,
            insdAddr6: plan.insdAddr6,
            postCode: plan.postCode,
            grpUppTxt: plan.grpUppTxt,
            grpLwrTxt: plan.grpLwrTxt
          }
          this.items.push(convertPlan)
        })
      } else {
        this.items = []
      }
    },
    cancelRiskGrpTxtDialog() {
      this.riskGrpTxtDialog = false
      this.mainForm.grpUppTxt = this.riskGrpTxtForm.grpUppTxt
      this.mainForm.grpLwrTxt = this.riskGrpTxtForm.grpLwrTxt
    },
    doRiskGrpTxtDialog() {
      this.riskGrpTxtDialog = true
      this.riskGrpTxtForm.grpUppTxt = this.mainForm.grpUppTxt
      this.riskGrpTxtForm.grpLwrTxt = this.mainForm.grpLwrTxt
    },
    saveRiskGrpTxtDialog() {
      this.riskGrpTxtForm.grpUppTxt = this.mainForm.grpUppTxt
      this.riskGrpTxtForm.grpLwrTxt = this.mainForm.grpLwrTxt
      this.doProceed('RiskGroupTxt')
    },
    doReset() {
      this.doInit()
    },
    doShowInsdRefNo(value) {
      this.insuredOrPerson = value
      this.showInsdRefNo = true
      this.$set(this.insured, 'insuredItems', [])
      this.fetchData()
    },
    doClearFilters() {
      this.filters.insdRefNo = null
      this.filters.name1 = null
      this.filters.icNo = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryInsdRefNoFilterForm').then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    // Find Insured Ref No. in Insured
    async fetchData() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.insuredList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this.insured, 'insuredItems', data)
            } else {
              this.$set(this.insured, 'insuredItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doSelectInsdRefNo(data) {
      if (this.insuredOrPerson === 'Insured') {
        this.mainForm.insdRefNo = data.insdRefNo
        this.mainForm.titleName = data.titleName
        this.mainForm.insdName1 = data.name1
        this.mainForm.insdName2 = data.name2
        this.mainForm.insdAddr1 = data.address1
        this.mainForm.insdAddr2 = data.address2
        this.mainForm.insdAddr3 = data.address3
        this.mainForm.insdAddr4 = data.address4
        this.mainForm.insdAddr5 = data.address5
        this.mainForm.insdAddr6 = data.address6
        this.mainForm.postCode = data.postalCode
      } else {
        this.personForm.insdRefNo = data.insdRefNo
        this.personForm.titleName = data.titleName
        this.personForm.insdName1 = data.name1
        this.personForm.insdName2 = data.name2
        this.personForm.icNo = data.icNo
      }
      this.copypersonForm = clone(this.personForm)
      this.showInsdRefNo = false
    },
    doMailAdd() {
      if (this.mainForm.mailAdd) {
        this.mainForm.insdRefNo = this.polMaster.insdRefNo
        this.mainForm.titleName = this.polMaster.titleName
        this.mainForm.insdName1 = this.polMaster.insdName1
        this.mainForm.insdName2 = this.polMaster.insdName2
        this.mainForm.insdAddr1 = this.polMaster.insdAddr1
        this.mainForm.insdAddr2 = this.polMaster.insdAddr2
        this.mainForm.insdAddr3 = this.polMaster.insdAddr3
        this.mainForm.insdAddr4 = this.polMaster.insdAddr4
        this.mainForm.insdAddr5 = this.polMaster.insdAddr5
        this.mainForm.insdAddr6 = this.polMaster.insdAddr6
        this.mainForm.postCode = this.polMaster.postCode
        this.disableInsured = true
      } else {
        this.disableInsured = false
      }
    },
    async getPolInsdDetList() {
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.insdList
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.mainForm.riskGrpNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          const { data } = result
          if (data) {
            this.person.personItems = []
            data.data.polInsdDetList.map((insdDet) => {
              const convertInsdDet = {
                riskGrpNo: insdDet.riskGrpNo,
                seqNo: insdDet.seqNo,
                insdRefNo: insdDet.insdRefNo,
                insdName1: insdDet.insdName1,
                icNo: insdDet.icNo,
                dob: insdDet.dob,
                dobFormat: this.formatDate(toDate(parseISO(insdDet.dob))),
                age: insdDet.age,
                gender: insdDet.gender,
                mStat: insdDet.mStat,
                occp: insdDet.occp,
                occpDesc: insdDet.occpDesc,
                relation: insdDet.relation,
                relationDesc: insdDet.relationDesc,
                titleName: insdDet.titleName // 2020-10-05 LYT OS-496
              }
              this.person.personItems.push(convertInsdDet)
            })
            this.prevEndtCntAvail = result.data.data.prevEndtCntAvail
            if (this.isPkgPlanScheme === true) {
              this.disableAll = false
              this.checkPlan()
            } else {
              this.checkPlan()
            }
          } else {
            this.person.personItems = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async checkPlan() {
      if (this.polMaster.tranType === 'N' || this.polMaster.tranType === 'R') {
        if (this.isPkgPlanScheme === true) {
          this.disablePlan = false
        } else {
          this.disablePlan = true
        }
      } else {
        this.disablePlan = this.prevEndtCntAvail === false
      }
    },
    async doSelectPerson(data) {
      this.policy.loading = true
      this.personForm.riskGrpNo = this.toStringEmpty(data.riskGrpNo)
      this.personForm.seqNo = this.toStringEmpty(data.seqNo)
      this.personForm.insdRefNo = this.toStringEmpty(data.insdRefNo)
      this.personForm.titleName = this.toStringEmpty(data.titleName)
      this.personForm.insdName1 = this.toStringEmpty(data.insdName1)
      this.personForm.insdName2 = this.toStringEmpty(data.insdName2)
      this.personForm.icNo = this.toStringEmpty(data.icNo)
      this.personForm.dob = this.toStringEmpty(data.dob)
      this.personForm.age = this.toStringEmpty(data.age)
      this.personForm.gender = this.toStringEmpty(data.gender)
      this.personForm.mStat = this.toStringEmpty(data.mStat)
      this.personForm.occp = this.toStringEmpty(data.occp)
      this.personForm.occpDesc = this.toStringEmpty(data.occpDesc)
      this.personForm.relation = this.toStringEmpty(data.relation)
      this.personForm.relationDesc = this.toStringEmpty(data.relationDesc)
      this.policy.loading = false
      this.showinsdPersons = true
      this.copypersonForm = clone(this.personForm)
    },
    async doPromptRemovePerson(data) {
      this.selectedPerson = data
      this.deletePersonTxt = 'Please Confirm to Delete Insured Reference ' + data.insdRefNo
      this.promptRemovePerson = true
    },
    async doRemovePerson(data) {
      this.policy.loading = true
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.delInsd
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.selectedPerson.riskGrpNo,
            seqNo: this.selectedPerson.seqNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result) {
            // 2020-09-30 LYT OS-461
            this.getPlanList().then(() => {
              this.setNoAdultChild()
            })

            const { data } = result
            if (data) {
              this.person.personItems = []
              data.data.map((insdDet) => {
                const convertInsdDet = {
                  riskGrpNo: insdDet.riskGrpNo,
                  seqNo: insdDet.seqNo,
                  insdRefNo: insdDet.insdRefNo,
                  insdName1: insdDet.insdName1,
                  icNo: insdDet.icNo,
                  dob: insdDet.dob,
                  dobFormat: this.formatDate(toDate(parseISO(insdDet.dob))),
                  age: insdDet.age,
                  gender: insdDet.gender,
                  mStat: insdDet.mStat,
                  occp: insdDet.occp,
                  occpDesc: insdDet.occpDesc,
                  relation: insdDet.relation,
                  relationDesc: insdDet.relationDesc,
                  titleName: insdDet.titleName // 2020-10-05 LYT OS-496
                }
                this.person.personItems.push(convertInsdDet)
              })
            } else {
              this.person.personItems = []
            }
            this.policy.loading = false
            this.showinsdPersons = false
          }
          this.$toast.success('Deleted Successfully')
        } catch (err) {
          this.policy.loading = false
          this.showinsdPersons = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      }
      this.personForm.seqNo = undefined
      this.policy.loading = false
    },
    async doAddPerson() {
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.addInsd
      if (apiUrl) {
        try {
          this.policy.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.mainForm.riskGrpNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result) {
            // 2020-09-30 LYT OS-461
            this.getPlanList().then(() => {
              this.setNoAdultChild()
            })

            const { data } = result
            if (data) {
              data.data.map((insdDet) => {
                const convertInsdDet = {
                  riskGrpNo: insdDet.riskGrpNo,
                  seqNo: insdDet.seqNo,
                  insdRefNo: insdDet.insdRefNo,
                  insdName1: insdDet.insdName1,
                  icNo: insdDet.icNo,
                  dob: insdDet.dob,
                  dobFormat: this.formatDate(toDate(parseISO(insdDet.dob))),
                  age: insdDet.age,
                  gender: insdDet.gender,
                  mStat: insdDet.mStat,
                  occp: insdDet.occp,
                  occpDesc: insdDet.occpDesc,
                  relation: insdDet.relation,
                  relationDesc: insdDet.relationDesc,
                  titleName: insdDet.titleName // 2020-10-05 LYT OS-496
                }
                this.person.personItems.push(convertInsdDet)

                const row = this.person.personItems.length - 1
                this.personForm.riskGrpNo = this.person.personItems[row].riskGrpNo
                this.personForm.seqNo = this.person.personItems[row].seqNo
                this.personForm.insdRefNo = this.toStringEmpty(this.person.personItems[row].insdRefNo)
                this.personForm.titleName = this.toStringEmpty(this.person.personItems[row].titleName)
                this.personForm.insdName1 = this.toStringEmpty(this.person.personItems[row].insdName1)
                this.personForm.insdName2 = this.toStringEmpty(this.person.personItems[row].insdName2)
                this.personForm.icNo = this.toStringEmpty(this.person.personItems[row].icNo)
                this.personForm.dob = this.toStringEmpty(this.person.personItems[row].dob)
                this.personForm.age = this.toStringEmpty(this.person.personItems[row].age)
                this.personForm.gender = this.toStringEmpty(this.person.personItems[row].gender)
                this.personForm.mStat = this.toStringEmpty(this.person.personItems[row].mStat)
                this.personForm.occp = this.toStringEmpty(this.person.personItems[row].occp)
                this.personForm.occpDesc = this.toStringEmpty(this.person.personItems[row].occpDesc)
                this.personForm.relation = this.toStringEmpty(this.person.personItems[row].relation)
                this.personForm.relationDesc = this.toStringEmpty(this.person.personItems[row].relationDesc)
                this.resetPersonForm.riskGrpNo = this.personForm.riskGrpNo
                this.resetPersonForm.seqNo = this.personForm.seqNo
                this.resetPersonForm.insdRefNo = this.personForm.insdRefNo
                this.resetPersonForm.titleName = this.personForm.titleName
                this.resetPersonForm.insdName1 = this.personForm.insdName1
                this.resetPersonForm.insdName2 = this.personForm.insdName2
                this.resetPersonForm.icNo = this.personForm.icNo
                this.resetPersonForm.dob = this.personForm.dob
                this.resetPersonForm.age = this.personForm.age
                this.resetPersonForm.gender = this.personForm.gender
                this.resetPersonForm.mStat = this.personForm.mStat
                this.resetPersonForm.occp = this.personForm.occp
                this.resetPersonForm.occpDesc = this.personForm.occpDesc
                this.resetPersonForm.relation = this.personForm.relation
                this.resetPersonForm.relationDesc = this.personForm.relationDesc
                this.showinsdPersons = true
                this.copypersonForm = clone(this.personForm)
              })
            } else {
              this.person.personItems = []
            }
            this.policy.loading = false
          }
        } catch (err) {
          this.policy.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    toStringEmpty(strData) {
      if (strData) {
        return strData
      } else {
        return ''
      }
    },
    async doSavePerson() {
      this.resetMessages()
      this.$validator.validateAll('personForm').then((result) => {
        if (result) {
          this.policy.loading = true
          this.personForm.polNo = this.polMaster.polNo
          this.personForm.renCnt = this.polMaster.renCnt
          this.personForm.endtCnt = this.polMaster.endtCnt
          this.personForm.riskGrpNo = this.mainForm.riskGrpNo
          this.doPolInsdSave().then((success) => {
            if (success) {
              this.displayPolInsdList()
              // 2020-09-30 LYT OS-461
              this.getPlanList().then(() => {
                this.setNoAdultChild()
              })

              // this.personForm.polNo = undefined
              // this.personForm.renCnt = undefined
              // this.personForm.endtCnt = undefined
              // this.personForm.riskGrpNo = undefined
              // this.personForm.seqNo = undefined
              // this.personForm.insdRefNo = undefined
              // this.personForm.titleName = undefined
              // this.personForm.insdName1 = undefined
              // this.personForm.insdName2 = undefined
              // this.personForm.icNo = undefined
              // this.personForm.dob = undefined
              // this.personForm.age = undefined
              // this.personForm.gender = undefined
              // this.personForm.mStat = undefined
              // this.personForm.occp = undefined
              // this.personForm.occpDesc = undefined
              // this.personForm.relation = undefined
              // this.personForm.relationDesc = undefined

              this.$toast.success('Insured Person Details Successfully Saved')
              this.showinsdPersons = false
            } else {
              this.$toast.error('Insured Person Details Failed')
            }
            this.policy.loading = false
            return true
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPolInsdSave() {
      try {
        // this.$store.commit(POLICY_INSURED_PERSON, this.personForm)
        if (isEqual(this.personForm, this.copypersonForm) === true) {
          return true
        } else {
          const result = await this.$store.dispatch('savePolInsdDet', this.personForm)
          if (result) {
            this.copypersonForm = clone(this.personForm)
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    },
    async displayPolInsdList() {
      this.person.personItems = []
      if (this.polMaster.polInsdDets) {
        this.polMaster.polInsdDets.map((insdDet) => {
          const convertInsdDet = {
            riskGrpNo: insdDet.riskGrpNo,
            seqNo: insdDet.seqNo,
            insdRefNo: insdDet.insdRefNo,
            insdName1: insdDet.insdName1,
            icNo: insdDet.icNo,
            dob: insdDet.dob,
            dobFormat: this.formatDate(toDate(parseISO(insdDet.dob))),
            age: insdDet.age,
            gender: insdDet.gender,
            mStat: insdDet.mStat,
            occp: insdDet.occp,
            occpDesc: insdDet.occpDesc,
            relation: insdDet.relation,
            relationDesc: insdDet.relationDesc,
            titleName: insdDet.titleName // 2020-10-05 LYT OS-496
          }
          this.person.personItems.push(convertInsdDet)
        })
      } else {
        this.person.personItems = []
      }
    },
    doResetPerson() {
      this.personForm.riskGrpNo = this.resetPersonForm.riskGrpNo
      this.personForm.seqNo = this.resetPersonForm.seqNo
      this.personForm.insdRefNo = this.resetPersonForm.insdRefNo
      this.personForm.titleName = this.resetPersonForm.titleName
      this.personForm.insdName1 = this.resetPersonForm.insdName1
      this.personForm.insdName2 = this.resetPersonForm.insdName2
      this.personForm.icNo = this.resetPersonForm.icNo
      this.personForm.dob = this.resetPersonForm.dob
      this.personForm.age = this.resetPersonForm.age
      this.personForm.gender = this.resetPersonForm.gender
      this.personForm.mStat = this.resetPersonForm.mStat
      this.personForm.occp = this.resetPersonForm.occp
      this.personForm.occpDesc = this.resetPersonForm.occpDesc
      this.personForm.relation = this.resetPersonForm.relation
      this.personForm.relationDesc = this.resetPersonForm.relationDesc
      this.copypersonForm = clone(this.personForm)
    },
    doDob() {
      if (this.polMaster.comDate && this.personForm.dob) {
        this.personForm.age = yearDiff(this.polMaster.comDate, this.personForm.dob)
      } else {
        this.personForm.age = undefined
      }
    },
    doOccp() {
      if (this.getOccpDesc.length > 0) {
        this.personForm.occpDesc = this.getOccpDesc[0].label
      }
    },
    doRelation() {
      if (this.getRelationDesc.length > 0) {
        this.personForm.relationDesc = this.getRelationDesc[0].label
      }
    },
    doExit() {
      this.$router.push({ name: 'policyListing' })
    },
    // async doProceed() {
    //   this.resetMessages()
    //   if (this.disableAll) {
    //     this.policy.loading = true
    //     // this.$store.dispatch('policyGroup', this.mainForm)
    //     this.doPolRiskGrpSave().then(success => {
    //       if (success) {
    //         this.$store.commit(POLICY_RISK_TAB, 1)
    //         this.$router.push({ name: 'policyRiskDetails' })
    //         // this.policy.false = true
    //       } else {
    //         this.$toast.error('Policy Save Failed')
    //       }
    //       this.policy.loading = false
    //     })
    //   } else {
    //     this.$validator.validateAll().then(result => {
    //       if (result) {
    //         this.policy.loading = true
    //         // this.$store.dispatch('policyGroup', this.mainForm)
    //         this.doPolRiskGrpSave().then(success => {
    //           if (success) {
    //             this.$store.commit(POLICY_RISK_TAB, 1)
    //             this.$router.push({ name: 'policyRiskDetails' })
    //             // this.policy.false = true
    //           } else {
    //             this.$toast.error('Policy Save Failed')
    //           }
    //           this.policy.loading = false
    //         })
    //       } else {
    //         this.$parent.$parent.changeTab(0)
    //         this.promptFieldCheck()
    //       }
    //     })
    //   }
    // },
    doLoadPreset() {
      this.riskGrpPresetDialog = true
      if (this.tabMenu === 0) {
        this.scrRef = '10'
        this.defTxt.items = this.defTxt.itemsUpperTxt
        this.defTxt.selected = this.defTxt.selectedUpperTxt
      } else {
        this.scrRef = '11'
        this.defTxt.items = this.defTxt.itemsLowerTxt
        this.defTxt.selected = this.defTxt.selectedLowerTxt
      }
    },
    doSelectTxt() {
      if (this.tabMenu === 0) {
        // this.defTxt.selectedUpperTxt = this.defTxt.selected
        // let uppTxt = ''
        // let displayUpperTxt = []
        // this.defTxt.displayUpperTxt = undefined
        // for (var i = 0; i < this.defTxt.selectedUpperTxt.length; i++) {
        //   displayUpperTxt.push(this.defTxt.selectedUpperTxt[i].defTxt + '\n')
        // }
        // for (let uT in displayUpperTxt) {
        //   uppTxt += displayUpperTxt[uT]
        // }
        // this.defTxt.displayUpperTxt = uppTxt
        if (this.mainForm.grpUppTxt.length > 0 && this.mainForm.grpUppTxt.charAt(this.mainForm.grpUppTxt.length - 1) !== '\n') {
          this.mainForm.grpUppTxt = this.mainForm.grpUppTxt + '\n'
        }
        for (var a = 0; a < this.defTxt.selected.length; a++) {
          this.mainForm.grpUppTxt = this.mainForm.grpUppTxt + this.defTxt.selected[a].defTxt + '\n'
        }
      } else {
        // this.defTxt.selectedLowerTxt = this.defTxt.selected
        // let lwrTxt = ''
        // let displayLowerTxt = []
        // this.defTxt.displayLowerTxt = undefined
        // for (i = 0; i < this.defTxt.selectedLowerTxt.length; i++) {
        //   displayLowerTxt.push(this.defTxt.selectedLowerTxt[i].defTxt + '\n')
        // }
        // for (let lT in displayLowerTxt) {
        //   lwrTxt += displayLowerTxt[lT]
        // }
        // this.defTxt.displayLowerTxt = lwrTxt
        if (this.mainForm.grpLwrTxt.length > 0 && this.mainForm.grpLwrTxt.charAt(this.mainForm.grpLwrTxt.length - 1) !== '\n') {
          this.mainForm.grpLwrTxt = this.mainForm.grpLwrTxt + '\n'
        }
        for (var b = 0; b < this.defTxt.selected.length; b++) {
          this.mainForm.grpLwrTxt = this.mainForm.grpLwrTxt + this.defTxt.selected[b].defTxt + '\n'
        }
      }
      this.riskGrpPresetDialog = false
    },
    async doEndorse() {
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.endorse
      if (apiUrl) {
        try {
          if (this.riskSelected.length > 0) {
            this.endorseForm.polNo = this.polMaster.polNo
            this.endorseForm.renCnt = this.polMaster.renCnt
            this.endorseForm.endtCnt = this.polMaster.endtCnt
            this.endorseForm.prevPolNo = this.riskSelected[0].polNo
            this.endorseForm.prevRenCnt = this.riskSelected[0].renCnt
            this.endorseForm.prevEndtCnt = this.riskSelected[0].endtCnt
            this.endorseForm.riskGrpNo = []
            this.endorseForm.riskNo = []
            this.riskSelected.map((select) => {
              this.endorseForm.riskGrpNo.push(select.riskGrpNo)
              this.endorseForm.riskNo.push(select.riskNo)
            })
            this.loading = true

            const result = await this.$http.post(apiUrl, this.endorseForm)
            const { data } = result
            if (data) {
              this.doInit()
            }
            this.loading = false
          } else {
            this.promptSelectRiskGrp = true
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCancel() {
      this.$store.commit(POLICY_LIFECYCLE, 2)
      this.$store.commit(POLICY_HEADER_TAB, 0)
      this.$router.push({ name: 'policyHeader' })
    },
    async doEndorsementAddGroup() {
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.addGroup
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.doInit()
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doEndorsementAddRisk() {
      const apiUrl = this.$store.state.underwriting.policyRiskGroupSettings.menu.addRisk
      if (apiUrl) {
        try {
          if (this.riskSelected.length > 0) {
            this.endorseForm.polNo = this.polMaster.polNo
            this.endorseForm.renCnt = this.polMaster.renCnt
            this.endorseForm.endtCnt = this.polMaster.endtCnt
            this.endorseForm.prevPolNo = this.riskSelected[0].polNo
            this.endorseForm.prevRenCnt = this.riskSelected[0].renCnt
            this.endorseForm.prevEndtCnt = this.riskSelected[0].endtCnt
            this.endorseForm.riskGrpNo = []
            this.endorseForm.riskNo = []
            this.riskSelected.map((select) => {
              this.endorseForm.riskGrpNo.push(select.riskGrpNo)
              this.endorseForm.riskNo.push(select.riskNo)
            })
            this.loading = true
            const result = await this.$http.post(apiUrl, this.endorseForm)
            const { data } = result
            if (data) {
              this.doInit()
            }
            this.loading = false
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doTab() {
      this.policy.loading = true
      await this.doPolRiskGrpSave()
      this.policy.loading = false
    },
    displayItemList(data) {
      if (data) {
        this.items = []
        data.data.map((plan) => {
          const convertPlan = {
            riskGrpNo: plan.riskGrpNo,
            planNo: plan.planNo,
            planDesc: plan.planDesc,
            noDay: plan.noDay,
            noAdult: plan.noAdult,
            noChild: plan.noChild,
            noLive: plan.noLive,
            insdPremises: plan.insdPremises,
            delRiskGrp: formatYesNo(plan.delRiskGrp),
            insdRefNo: plan.insdRefNo,
            titleName: plan.titleName,
            insdName1: plan.insdName1,
            insdName2: plan.insdName2,
            insdAddr1: plan.insdAddr1,
            insdAddr2: plan.insdAddr2,
            insdAddr3: plan.insdAddr3,
            insdAddr4: plan.insdAddr4,
            insdAddr5: plan.insdAddr5,
            insdAddr6: plan.insdAddr6,
            postCode: plan.postCode,
            grpUppTxt: plan.grpUppTxt,
            grpLwrTxt: plan.grpLwrTxt
          }
          this.items.push(convertPlan)
        })
        this.loading = false
      } else {
        this.items = []
        this.loading = false
      }
    },
    setNoAdultChild() {
      if (this.getSelectedRiskGrp.length > 0) {
        this.mainForm.noAdult = this.getSelectedRiskGrp[0].noAdult
        this.mainForm.noChild = this.getSelectedRiskGrp[0].noChild
      }
    },
    closeDialog() {
      this.promptSelectRiskGrp = false
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyRiskGroupSettings.init !== 1) {
      this.$store.dispatch('policyRiskGroupInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>
